import { ArtButton } from "components/button";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAuthInfos } from "reducer/wallet.slice";
import {
    Modal,
} from "semantic-ui-react";
import { api, ui } from "services";
import { PasswordInput } from "../../components/input/password-input";

export default function ChangePasswordPopup({ open, onClose }: any) {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();
    const dispatch = useDispatch();
    function close() {
        onClose();
    }
    const onSubmit = async () => {
        setLoading(true);
        try {
            const data = await api.changePassword(currentPassword, newPassword);
            ui.alertSuccess("Change password", "Change password successful !");
            dispatch(setAuthInfos([data]))
            resetState();
            onClose();
        } catch (err: any) {
            ui.alertFailed(
                "Change password failed !",
                "Your password is not valid ! Please try again later !"
            );
            resetState();
            onClose();
        }
    }
    const resetState = () => {
        setLoading(false);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
    }
    useEffect(() => {
    }, [currentPassword, newPassword, confirmPassword])
    return (
        <Modal
            size="small"
            open={open}
            style={{ width: "unset" }}
        >
            <div
                className="max-w-[564px] w-screen"
            >
                <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
                    <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            Change password
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-6" />

                        <form className="w-11/12 mx-auto">
                            <PasswordInput
                                autoFocus
                                fieldName="Password"
                                setPassword={setCurrentPassword}
                                password={currentPassword}
                                submit={onSubmit}
                            />
                            <div className="text-orange float-right mb-6 cursor-pointer"
                                onClick={() => nav('/forgot-password')}
                            >
                                Forgot password?
                            </div>
                            <PasswordInput
                                submit={onSubmit}
                                fieldName="New password" setPassword={setNewPassword} password={newPassword} className="my-4" />
                            <PasswordInput
                                submit={onSubmit}
                                fieldName="Confirm password"
                                setPassword={setConfirmPassword}
                                password={confirmPassword}
                                validation={(data: any) => {
                                    if (data !== newPassword) {
                                        return "Confirm password not match with new password"
                                    }
                                    return "";
                                }}
                            />
                        </form>

                        <div className={`flex w-[360px] gap-4 mt-6 text-center items-center mx-auto`}>
                            <ArtButton color="red"
                                disabled={loading}
                                onClick={() => {
                                    close();
                                    resetState();
                                }}
                            >
                                <div className="text-white font-semibold">
                                    Cancel
                                </div>
                            </ArtButton>
                            <ArtButton color="yellow"
                                loading={loading}
                                onClick={onSubmit}
                            >
                                <div className="text-white font-semibold">
                                    Save
                                </div>
                            </ArtButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
